export default {
  headingColor: Styles.color.grey.one,
  centeredTextColor: Styles.color.grey.one,
};
